export default "__VITE_ASSET__CluWV9vq__"